import { createDraftSafeSelector, createSelector } from '@reduxjs/toolkit'
import { rolesApi, UserRoleEnum } from 'api/roles'
import userApi from './user.service'

export const getUser = userApi.endpoints.getUser.select()
export const getUserSettings = userApi.endpoints.getUserSettings.select()

const getRoles = rolesApi.endpoints.getRole.select({})

export const getClientWithRoleAndClientId = createDraftSafeSelector(
  [getRoles],
  (roles) => (role: UserRoleEnum, clientId: string) =>
    roles?.data
      ?.filter((x) => x.role === role)
      .find(({ reference }) =>
        reference.some(
          ({ type, value }) => type === 'ClientId' && value === clientId
        )
      )
)

export const getUserFullname = createSelector(getUser, (state) => {
  if (!state.data) return ''

  return `${state.data.firstname ? state.data.firstname + ' ' : ''}${
    state.data.surname
  }`
})
